import React, { useEffect, useState } from "react";
import { useQuery } from "react-query";
import StudentsModal from "src/components/StudentsModal";
import { useDialog } from "src/contexts/dialog-context";
import { useStudent } from "src/contexts/student";
import { ProtocolLI } from "src/modules/fithub-shared/interfaces/protocol";
import api from "src/rest/api";
import { StudentList } from "src/screens/students-list";
import { GetPlansList } from "../cache/protocol-manager";
import TemplatesBrowser from "../components/templates-browser";
import { PlanContextProvider } from "../context";
import View from "./View";

// import { Container } from './styles';

const Plan: React.FC = () => {
  const [exportPlan, setExport] = useState<string>();

  const [importPlan, setImportPlan] = useState(false);

  const { student } = useStudent();

  const list = useQuery<ProtocolLI[]>(
    ["List", student?.id ?? "Templates"],

    () => GetPlansList(student?.id),
  );

  useEffect(() => {
    console.log("Plan.tsx effected");
  }, []);

  function handleDuplicate(id: string) {
    api
      .post("/protocols/duplicate", {
        id: id,
      })
      .then(() => {
        list.refetch();
      })
      .catch((err) => {
        alert("Não foi possivel duplicar protocolo!\n" + err);
      });
  }

  function handleSaveTemplate(id: string) {
    api
      .post("/protocols/template/save", {
        id: id,
      })
      .then((res) => {
        if (res.status !== 200) alert(res.data);
      })
      .catch((err) => {
        alert(err);
      });
  }

  async function _importProtocol(e: string, i: string) {
    if (student)
      await api
        .post("/protocols/import", {
          id: i,
          ref: student.id,
        })
        .then(() => list.refetch())
        .catch((err) => {
          alert(err);
        });
  }

  function _selectStudent(s: StudentList) {
    if (exportPlan === undefined) return;
    if (student && s.id === student.id) {
      return;
    }

    api
      .post("/protocols/export", {
        id: exportPlan,
        student_id: s.id,
      })
      .then(() => {
        //TODO: Adicionar Alerta (hook)
      })
      .catch((err) => {
        //TODO: Adicionar Alerta (hook)
      });

    setExport(undefined);
  }

  const dialog = useDialog();

  function _RemoveProtocol(id: string, callback: () => void) {
    dialog.openDialog(
      "Remover Protocolo",
      "Gostaria de remover este protocolo permanentemente?",
      () =>
        api
          .post("/protocols/delete", { id })
          .then(() => {
            //TODO: Adicionar Alerta (hook)
            callback();
            list.refetch();
          })
          .catch((err) => {
            alert(JSON.stringify(err, null, 2));
          }),
    );
  }

  return (
    <PlanContextProvider list={list}>
      <View
        student={student?.id}
        list={list.data}
        isTemplates={false}
        loadingList={list.isLoading}
        handleRemoveProtocol={_RemoveProtocol}
        handleDuplicate={handleDuplicate}
        handleExport={setExport}
        handleSaveTemplate={handleSaveTemplate}
        handleImport={() => setImportPlan(true)}
      />

      <StudentsModal
        onSelect={_selectStudent}
        active={Boolean(exportPlan)}
        setActive={(value) => setExport(value ? exportPlan : undefined)}
      />

      <TemplatesBrowser
        active={importPlan}
        type="Protocol"
        headerTitle="Importar Plano"
        onSelect={_importProtocol}
        onDismis={setImportPlan}
      />
    </PlanContextProvider>
  );
};

export default Plan;
